<template>
  <div class="affiliates">
    <div class="affiliates-container">
      <p class="affiliates-title">
        About
        <span class="text-blue-400">Spring Financial</span>
      </p>
      <br>
      <p class="text-md">
        At Spring Financial, our mission is to give any Canadian access to fair priced financial products.
        We’ve built innovative products that allow anybody to get started (or re-started) on their credit journey regardless of their financial past.
        All our products are designed to help any Canadian access the credit they need and save money all over their mobile phone without leaving their home.
      </p>
      <div class="affiliates-info">
        <div
          v-for="(item, index) in info"
          :key="index"
          class="my-10"
        >
          <div class="flex justify-center">
            <img
              class="affiliates-info__image"
              :src="require('@/assets/svg/spring.svg')"
            >
            <p class="affiliates-info__title">
              {{ item.title }}
            </p>
          </div>

          <p class="text-md">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang=scss scoped>

.affiliates {
  @apply max-w-520 mx-auto;

  &-container {
    @apply mt-55 sm:mt-100 text-center mx-10;
  }

  &-title {
    @apply font-heading text-xl sm:text-2xl font-semibold;
  }

  &-info {
    @apply mt-20;

    &__image {
      @apply text-2xl mr-10;
    }

    &__title {
      @apply text-lg pt-10 font-semibold mb-10;

      text-wrap: nowrap;
    }
  }
}

</style>

<script>
export default {
  name: 'ContactCodeAffiliatesFooter',

  data () {
    return {
      info: [
        {
          title: 'Fast Funding',
          description: 'We provide same-day funding at no extra cost. You can get approved and funded quickly (usually within 24 hours) via EFT or e-Transfer.'
        },
        {
          title: 'Easy Access',
          description: 'Apply online and one of their agents will reach out to you by phone or by text. You can complete all of your documents online or on your smartphone.'
        },
        {
          title: 'All Credit Scores Are Welcome',
          description: 'While other lenders have minimum credit score requirements before they even look at an application, We works with customers facing a variety of financial situations to responsibly approve loans for every credit rating.'
        }]
    }
  }
}
</script>
